<template>
  <section class="page-container">
    <h1>Gift Cards</h1>
    <!--    <div class="btn-top-container">-->
    <!--      <v-button-->
    <!--        type="plain"-->
    <!--        size="mini"-->
    <!--        :disabled="isDisable"-->
    <!--        @click="handlerDown"-->
    <!--      >Export Excel-->
    <!--      </v-button>-->
    <!--    </div>-->
    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        :prefixIcon="'el-icon-search'"
        placeholder="Customer Name"
        @keyEnter="filterData" />
    </div>
    <div class="filter-card">

      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Created</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Redeemed</span>
            <v-date-picker
              v-model="redeemedDate"
              type="daterange"
              @change="filterData" />
          </div>
        </div>
      </div>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          label="Number">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>{{row.card_no}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="contact_nm"
          label="Redeemed">
          <template #default="{ row }">
            <span
              v-if="row.got_dt"
              class="time">{{ row.got_dt.split(" ")[0] }}</span><br>
            <span
              v-if="row.got_dt"
              class="time"> {{ row.got_dt.split(" ")[1] }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Customer">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                {{ row.customer }}
              </span>
              <p></p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="price"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>{{row.status}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Value">
          <template #default="{ row }">
            <div class="flex-algin">
              <span  >{{row.card_value}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="quote_dt"
          width="160"
          label="Created">
          <template #default="{ row }">
            <span class="time">{{ row.created_at.split(" ")[0] }}</span><br>
            <span class="time"> {{ row.created_at.split(" ")[1] }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Expiry">
          <template #default="{ row }">
            <span class="time">{{ row.expire_dt.split(" ")[0] }}</span><br>
            <span class="time"> {{ row.expire_dt.split(" ")[1] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {mapActions, mapState} from 'vuex'
import {getGiftList} from '@/api/gift'
import {downloadFile} from '@/utils/download'

export default {
  name: 'TicketReport',

  mixins: [MixinOptions],
  props:{

  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      date: '',
      redeemedDate: '',
      tableData: [],
      search:''
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
    isDisable(){
      return false
    },
    manual_quote_product(){
      return this.globalOptions.manual_quote_product
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getGiftList()
      }
    }
  },
  methods: {
    ...mapActions('quote', ['setIsBack']),
    handlerDown(){
      this.network().getReportDownload()
    },
    rowClick(row) {
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getGiftList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getGiftList()
    },
    network() {
      return {
        getGiftList: async () => {
          const { data } = await getGiftList({
            created_start: this.date[0],
            created_end: this.date[1],
            redeemed_start: this.redeemedDate[0],
            redeemed_end: this.redeemedDate[1],
            search_text:this.search,
            page: this.pageConfig.currentPage,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getReportDownload: async () => {
          const res= await getReportDownload({
            user_type: this.user_type,
            website_type: this.website_type,
            class_id: this.class_id,
            created_start: this.date[0],
            search_text:this.search,
            created_end: this.date[1],
          })
          downloadFile(res)
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .text-date{
    font-size: 12px;
  }
  .filter-top{
    margin-bottom: 30px;
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }

  }
  .span-name {
    display: block;
    color: #24292E;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 500;
  }
  .form-half {
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
  }
  .filter-card {
    margin-bottom: 30px;
    margin-top: 15px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .filter-main {
      //display: flex;
      padding: 0 15px;
      .filter-left{
        padding: 15px 0;
        display: flex;
        //justify-content: space-between;
        .form-item{
          margin-right: 30px;
        }
      }
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;
    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
  .margin-top-flex{
    margin-top: 5px;
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
    .content-pending{
      height: 22px;
      width: 22px;
      margin-right: 10px;
    }
  }
  .el-table{
    ::v-deep .flex-algin{
      display: flex;
      flex-direction: column;
      justify-content:space-between ;
      p{
        height: 24px;
      }
      span{
        font-size: 14px;
        line-height: 20px;
        color: #24292E;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .time{
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
  }
  .blue{
    color: #0366D6;
    cursor: pointer;
  }
}
</style>
